<template>
  <!--<div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
  </div>-->
  <f7-app :params="f7params">
    <!-- initial page is specified in routes.js -->
      <pageWrapper>
        <f7-view url="/" :main="true" class="safe-areas" :master-detail-breakpoint="800" :push-state="true"></f7-view>
      </pageWrapper>
    <session-refresh-modal/>
    <div id="wandr-page-loading"></div>
  </f7-app>
</template>

<style>

@import './styles/Mulish.css';

</style>

<script>
  import { f7App, f7View } from 'framework7-vue';
  import routes from './router/routes';
  import pageWrapper from './components/page-wrapper.vue';
  import { mapGetters, mapActions } from "vuex";

  /*
  Now we need to map components to routes.
  We need to pass them along with the F7 app parameters to <f7-app> component
  */

  export default {
    components: {
      f7App,
      f7View,
      pageWrapper
    },
    computed: {
      ...mapGetters('misc', ['screenWidth', 'screenHeight', 'initScreenHeight'])
    },
    data() {
      let theme = 'aurora';
      if (document.location.search.indexOf('theme=') >= 0) {
        theme = document.location.search.split('theme=')[1].split('&')[0];
      }

      return {
        // app params
        f7params: {
          name: 'Wandr-E',
          id: 'com.wandr.wandrapp',
          theme,
          routes,
          cache: false,
          cacheDuration: 0,
        },
      };
    },
    mounted() {
      document.onkeydown = function (e) {
        // disable F12 and ctrl+shift+i
        if(e.keyCode === 123 || (e.ctrlKey && e.shiftKey && e.keyCode===73)) {
          return false;
        }
      }

      document.addEventListener("contextmenu", (e)=>{e.preventDefault()});
      
      this.setInitScreenHeight(window.innerHeight);
      this.setScreenWidth(window.innerWidth);
      this.setScreenHeight(window.innerHeight);
      //console.log("W: "+window.innerWidth+"\nH: "+window.innerHeight+"\n")

      window.addEventListener('resize', async () => {
        //console.log("SCREEN SIZE CHANGED")
        //console.log("INIT H : "+this.initScreenHeight+"\nNEW H : "+window.innerHeight)

        if(this.initScreenHeight != window.innerHeight){
          await this.setInitScreenHeight(window.innerHeight)
        }

        await this.setScreenWidth(window.innerWidth);
        await this.setScreenHeight(window.innerHeight);
        //console.log("SCREEN SIZE CHANGED\nW: "+this.screenWidth+"\nH: "+this.screenHeight)
      });
    },
    methods: {
      ...mapActions('misc', ['setScreenWidth', 'setScreenHeight', 'setInitScreenHeight'])
    }
  }
</script>